import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, UntypedFormControl, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'gtd-text-editor',
  templateUrl: './text-editor.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => TextEditorComponent),
    },
  ],
})
export class TextEditorComponent implements ControlValueAccessor {
  @Input() control: UntypedFormControl;
  @Input() customClass: string;
  @Input() label: string;
  public data: string;
  public disabled: boolean;
  public placeholder = $localize`:@@ui-kit.enter_text_with_dots:Enter text...`;
  private onChange: (value: string) => void;
  private onTouch: () => void;

  registerOnChange(fn: (value) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouch = fn;
  }

  writeValue(data: string): void {
    this.data = data;
  }

  updateValue(data: string) {
    this.data = data;
    this.onChange(data);
    this.onTouch();
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }
}
